import { Component, createSignal } from "solid-js";
import DefaultModal from "../elements/DefaultModal";
import HeaderModal from "../elements/HeaderModal";

import Alert from "../assets/icons/alert.svg";

import Styles from "bundle-text:../styles/_connectToMailingBossModal.scss";

interface ConnectToMailingBossModalProps {
  show: boolean;
  onClose: () => void;
  onBack?: () => void;
  onNext?: () => void;
}

const ConnectToMailingBossModal: Component<ConnectToMailingBossModalProps> = (
  props
) => {
  const [navigate, setNavigate] = createSignal(1);
  const steps = [
    { id: 1, label: "DKIM" },
    { id: 2, label: "SPF" },
    { id: 3, label: "SMARC" },
    { id: 4, label: "CNAME" },
  ];

  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text).then(
      () => {
        console.log("Copied to clipboard:", text);
      },
      (err) => {
        console.error("Could not copy text: ", err);
      }
    );
  };

  return (
    <>
      <style>{Styles}</style>
      <DefaultModal show={props.show} topBar={40}>
        <HeaderModal
          title="Connect your domain to MailingBoss only"
          onClose={props.onClose}
          onBack={props.onBack}
        />
        <div className="connect-to-mailingBoss">
          <p>
            In this step you need to configure four DNS records on your domain
            hosting provider. Each record is required to ensure correct setup
            and delivery of emails from your account. If you're not sure how to
            create these records, contact your domain hosting provider's support
            and provide the information on this page to complete the process.
          </p>

          <nav>
            {steps.map((step) => (
              <button
                classList={{ active: navigate() === step.id }}
                onClick={() => setNavigate(step.id)}
              >
                #{step.id}: {step.label}
              </button>
            ))}
          </nav>

          <section>
            <div className="form-group">
              <label>Type</label>
              <div className="inline">
                <input type="text" readonly />
                <button onClick={() => copyToClipboard("Type")}>
                  <builderall-icon code="b54c"></builderall-icon>
                </button>
              </div>
            </div>
            <div className="form-group">
              <label>Name</label>
              <div className="inline">
                <input type="text" readonly />
                <button onClick={() => copyToClipboard("Name")}>
                  <builderall-icon code="b54c"></builderall-icon>
                </button>
              </div>
            </div>
            <div className="form-group">
              <label>Value</label>
              <div className="inline">
                <input type="text" readonly />
                <button onClick={() => copyToClipboard("Value")}>
                  <builderall-icon code="b54c"></builderall-icon>
                </button>
              </div>
            </div>
          </section>

          <div className="alert">
            <img src={Alert} alt="Alert" />
            <span>
              DNS records can take from 20 minutes up to 48 hours to propagate.
              When propagation is complete and the records are detected, your
              domain will be marked as "verified”and SSL will be added. Once
              your domain is verified and SSL is active, you are ready to start
              sending with MailingBoss.
            </span>
          </div>

          <footer>
            <a href="#">
              <builderall-icon code="help"></builderall-icon>
              SEE EXAMPLES
            </a>
            <button onClick={props.onNext}>next</button>
          </footer>
        </div>
      </DefaultModal>
    </>
  );
};

export default ConnectToMailingBossModal;
